import { AxiosRequestConfig } from 'axios'
import { useMutator as useOrvalMutator } from '@dhl/receiver-axios'

export const baseUrl = '/receiver-preference-api'

export const useMutator = <T>(): ((config: AxiosRequestConfig) => Promise<T>) => useOrvalMutator(baseUrl)
